// Función para obtener el valor de una propiedad anidada
export function getNestedValue(obj: any, path: string): any {
    return path.split(".").reduce((acc, part) => acc?.[part], obj);
}
